import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  CONSENT_EVENT,
  hasCookieConsent,
  initMetaPixel,
  trackPixelPageView,
} from "@/lib/metaPixel";

/**
 * Charge le Meta Pixel dès que le consentement est donné, puis déclenche
 * un PageView au chargement et à chaque changement de route (SPA).
 */
const MetaPixelRouteTracker = () => {
  const { pathname, search } = useLocation();
  const [consent, setConsent] = useState(() => hasCookieConsent());

  useEffect(() => {
    const onChange = () => setConsent(hasCookieConsent());
    window.addEventListener(CONSENT_EVENT, onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener(CONSENT_EVENT, onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);

  useEffect(() => {
    if (!consent) return;
    initMetaPixel();
    trackPixelPageView();
  }, [consent, pathname, search]);

  return null;
};

export default MetaPixelRouteTracker;
